<p-toast position="top-right"></p-toast>
<p-sidebar [(visible)]="showApproveMartPartner"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="close()"
           [style]="{width:'700px'}">
  <ng-template pTemplate="header">
    <div>
      <div class="flex flex-row">
        <div class="mart-approve-header-bold">For Approval:</div>
        <div class="mart-approve-header-company">{{merchant.PartnerName}}</div>
      </div>
      <div class="mart-approve-header-description">Ensure details are accurate</div>
    </div>
  </ng-template>

  <div class="bx-pager bx-default-pager">
    <div class="bx-pager-item active">
      <a class="bx-pager-link " data-slide-index="0">SEC Details</a>
      <div class="arrow">

      </div>
    </div>
    <div class="bx-pager-item" [class.active]="activeTab !== approveMenuTab.SEC">
      <a class="bx-pager-link" data-slide-index="1">BIR 2303</a>
      <div class="arrow">

      </div>
    </div>
    <div class="bx-pager-item"
         [class.active]="(activeTab === approveMenuTab.PersonalId || activeTab === approveMenuTab.Fees)">
      <a class="bx-pager-link" data-slide-index="2">Personal ID</a>
      <div class="arrow">

      </div>
    </div>
    <div class="bx-pager-item" [class.active]="activeTab === approveMenuTab.Fees">
      <a class="bx-pager-link" data-slide-index="3">Fees</a>
    </div>
  </div>

  <div class="approve-body" *ngIf="activeTab === approveMenuTab.SEC">
    <p-scrollPanel [style]="{width:'100%', height: 'calc(73vh)'}"
                   [styleClass]="'app-scrollpanel'">

      <p-image src="{{merchant.secImageUrl}}" alt="Image" [preview]="true" height="350"></p-image>
      <div class="horizontal-line"></div>
      <div class="approve-item-description">Please verify the following information:</div>
      <div class="flex flex-row mb-2">
        <div class="approve-item-label" style="margin-right: 30px; margin-top: 3px;">Is the document valid/legible?</div>
        <div><p-inputSwitch [(ngModel)]="secDocsIsLegible"></p-inputSwitch></div>
        <div class="approve-inputswitch-label" [ngClass]="{
          'approve-inputswitch-label-false': secDocsIsLegible === false,
          'approve-inputswitch-label-true': secDocsIsLegible === true}">
          {{secDocsIsLegible ? "Yes" : "No"}}
        </div>
      </div>
      <div class="flex flex-row">
        <div class="approve-item-label" style="margin-right: 30px; margin-top: 3px;">Does the registered company name match?</div>
        <div><p-inputSwitch [(ngModel)]="secCompNameIsCorrect"></p-inputSwitch></div>
        <div class="approve-inputswitch-label" [ngClass]="{
          'approve-inputswitch-label-false': secCompNameIsCorrect === false,
          'approve-inputswitch-label-true': secCompNameIsCorrect === true}">
          {{secCompNameIsCorrect ? "Yes" : "No"}}
        </div>
      </div>
      <div style="margin-top: 5px;" class="approve-company-name">{{merchant.businessName}}</div>
      <div class="approve-item-label approve-input-label">Enter Company TIN</div>
      <input type="text" [(ngModel)]="companyTin" pInputText class="approve-input-text approve-input" placeholder="Company TIN">
      <small class="error-message" *ngIf="!companyTin">Company TIN is required.</small>
      <div class="approve-item-label approve-input-label">Enter Company Registration Number</div>
      <input type="text" [(ngModel)]="compRegistrNumber" pInputText class="approve-input-text approve-input" placeholder="CR Number">
      <small class="error-message" *ngIf="!compRegistrNumber">Company Registration Number is required.</small>
    </p-scrollPanel>
    <hr class="hr-filter" />
    <div class="flex justify-content-end mrg-10-0px">
      <button *ngIf="secCompNameIsCorrect && secDocsIsLegible" [disabled]="!companyTin || !compRegistrNumber" class="btn-darkblue" pButton label="Next" (click)="nextTab(approveMenuTab.BIR)"></button>
      <button (click)="showRejectPopupHandle()" *ngIf="!secCompNameIsCorrect || !secDocsIsLegible" class="btn-danger" style="float: right; margin-left: auto;" pButton label="Decline"></button>
    </div>
  </div>

  <div class="approve-body" *ngIf="activeTab === approveMenuTab.BIR">
    <p-scrollPanel [style]="{width:'100%', height: 'calc(73vh)'}"
                   [styleClass]="'app-scrollpanel'">
      <p-image src="{{merchant.birImageUrl}}" alt="Image" [preview]="true" height="350"></p-image>
      <div class="horizontal-line"></div>
      <div class="approve-item-description">Please verify the following information:</div>
      <div class="flex flex-row mb-2">
        <div class="approve-item-label" style="margin-right: 30px; margin-top: 3px;">Is the document valid/legible?</div>
        <div><p-inputSwitch [(ngModel)]="birDocsIsLegible"></p-inputSwitch></div>
        <div class="approve-inputswitch-label" [ngClass]="{
          'approve-inputswitch-label-false': birDocsIsLegible === false,
          'approve-inputswitch-label-true': birDocsIsLegible === true}">
          {{birDocsIsLegible ? "Yes" : "No"}}
        </div>
      </div>
      <div class="flex flex-row">
        <div class="approve-item-label" style="margin-right: 30px; margin-top: 3px;">Does the registered company name match?</div>
        <div><p-inputSwitch [(ngModel)]="birCompNameIsCorrect"></p-inputSwitch></div>
        <div class="approve-inputswitch-label" [ngClass]="{
          'approve-inputswitch-label-false': birCompNameIsCorrect === false,
          'approve-inputswitch-label-true': birCompNameIsCorrect === true}">{{birCompNameIsCorrect ? "Yes" : "No"}}</div>
      </div>
      <div style="margin-top: 5px;" class="approve-company-name">{{merchant.businessName}}</div>
      <div class="approve-item-label approve-input-label">Date of Document</div>
      <p-calendar [(ngModel)]="birDateIssue" [inputStyle]="{background: '#F2F5F7', 'border': '0.5px solid #0040604D', 'border-radius': '10px'}" class="approve-input-text" [style]="{'width':'90%'}" placeholder="Enter Date" [maxDate]="currentDay"></p-calendar>
      <small class="error-message" *ngIf="!birDateIssue">Date of Document is required.</small>
    </p-scrollPanel>
    <hr class="hr-filter" />
    <div class="flex justify-content-space-between  mrg-10-0px">
      <button class="btn-darkblue" style="float: left;" pButton label="Back" (click)="nextTab(approveMenuTab.SEC)"></button>
      <button *ngIf="birCompNameIsCorrect && birDocsIsLegible" [disabled]="!birDateIssue" class="btn-darkblue" style="float: right; margin-left: auto;" pButton label="Next" (click)="nextTab(approveMenuTab.PersonalId)"></button>
      <button (click)="showRejectPopupHandle()" *ngIf="!birCompNameIsCorrect || !birDocsIsLegible" class="btn-danger" style="float: right; margin-left: auto;" pButton label="Decline"></button>
    </div>
  </div>

  <div class="approve-body" *ngIf="activeTab === approveMenuTab.PersonalId">
    <p-scrollPanel [style]="{width:'100%', height: 'calc(73vh)'}"
                   [styleClass]="'app-scrollpanel'">
      <p-image src="{{merchant.personalIdImageUrl}}" alt="Image" [preview]="true" height="350"></p-image>
      <div class="horizontal-line"></div>
      <div class="approve-item-description">Please verify the following information:</div>
      <div class="flex flex-row mb-2">
        <div class="approve-item-label" style="margin-right: 30px; margin-top: 3px;">Is the document valid/legible?</div>
        <div><p-inputSwitch [(ngModel)]="personalIdIsLegible"></p-inputSwitch></div>
        <div class="approve-inputswitch-label" [ngClass]="{
          'approve-inputswitch-label-false': personalIdIsLegible === false,
          'approve-inputswitch-label-true': personalIdIsLegible === true}">
          {{personalIdIsLegible ? "Yes" : "No"}}
        </div>
      </div>
      <div class="flex flex-row">
        <div class="approve-item-label" style="margin-right: 30px; margin-top: 3px;">Does the name match?</div>
        <div><p-inputSwitch [(ngModel)]="personalIdNameIsCorrect"></p-inputSwitch></div>
        <div class="approve-inputswitch-label" [ngClass]="{
          'approve-inputswitch-label-false': personalIdNameIsCorrect === false,
          'approve-inputswitch-label-true': personalIdNameIsCorrect === true}">{{personalIdNameIsCorrect ? "Yes" : "No"}}</div>
      </div>
      <div style="margin-top: 5px;" class="approve-company-name">{{merchant.userName}}</div>
      <div class="flex flex-row approve-inputswitch-group-item">
        <div class="approve-item-label" style="margin-right: 30px; margin-top: 3px;">Is the drivers license clear and readable?</div>
        <div><p-inputSwitch [(ngModel)]="personalIdIsReadable"></p-inputSwitch></div>
        <div class="approve-inputswitch-label" [ngClass]="{
          'approve-inputswitch-label-false': personalIdIsReadable === false,
          'approve-inputswitch-label-true': personalIdIsReadable === true}">{{personalIdIsReadable ? "Yes" : "No"}}</div>
      </div>
      <div class="flex flex-row">
        <div class="approve-item-label" style="margin-right: 30px; margin-top: 3px;">Is the drivers license current?</div>
        <div><p-inputSwitch [(ngModel)]="personalIdIsActually"></p-inputSwitch></div>
        <div class="approve-inputswitch-label" [ngClass]="{
          'approve-inputswitch-label-false': personalIdIsActually === false,
          'approve-inputswitch-label-true': personalIdIsActually === true}">{{personalIdIsActually ? "Yes" : "No"}}</div>
      </div>
    </p-scrollPanel>
    <hr class="hr-filter" />
    <div class="flex justify-content-space-between  mrg-10-0px">
      <button class="btn-darkblue" style="float: left;" pButton label="Back" (click)="nextTab(approveMenuTab.BIR)"></button>
      <button *ngIf="personalIdNameIsCorrect && personalIdIsReadable && personalIdIsActually && personalIdIsLegible" class="btn-darkblue"
              style="float: right; margin-left: auto;" pButton label="Next" (click)="nextTab(approveMenuTab.Fees)"></button>
      <button (click)="showRejectPopupHandle()" *ngIf="!personalIdNameIsCorrect || !personalIdIsReadable || !personalIdIsActually || !personalIdIsLegible" class="btn-danger" style="float: right; margin-left: auto;" pButton label="Decline"></button>
    </div>
  </div>

  <div class="approve-body" *ngIf="activeTab === approveMenuTab.Fees">
    <p-scrollPanel [style]="{width:'100%', height: 'calc(73vh)'}"
                   [styleClass]="'app-scrollpanel'">
      <div style="letter-spacing: 0px; color: #272D3B; opacity: 1; font-size: 16px; margin-bottom: 15px;">Service Fee</div>
      <div class="flex flex-row">
          <p-inputNumber class="service-fee-input-item" [ngStyle]="{'margin-right': '40px;', 'margin-left': '3px;'}" [inputStyle]="{background: '#F2F5F7', 'border': '0.5px solid #0040604D', 'border-radius': '10px'}" [(ngModel)]="amountFee" [minFractionDigits]="2" placeholder="Enter amount"></p-inputNumber>
          <p-dropdown [options]="feeTypes" [(ngModel)]="selectedServiceFee" placeholder="Select" optionLabel="name" class="service-fee-input-item" ></p-dropdown>
      </div>
    </p-scrollPanel>
    <hr class="hr-filter" />
    <div class="flex justify-content-space-between  mrg-10-0px">
      <button class="btn-darkblue" style="float: left;" pButton label="Back" (click)="nextTab(approveMenuTab.PersonalId)"></button>
      <button [disabled]="!selectedServiceFee || !amountFee" (click)="approveMerchantDocs()" pButton type="button" style="float: right; margin-left: auto" label="Approve" class="p-button-success"></button>
    </div>
  </div>

  <p-dialog header="Decline Application" [(visible)]="showRejectPopup" [modal]="true" [style]="{width: '600px'}"
            [draggable]="false" [resizable]="false">
    <p class="m-0">Specify the reason why you decline the application.</p>
    <textarea [(ngModel)]="rejectReason" style="margin-top: 10px;" rows="8" cols="70" pInputTextarea></textarea>
    <ng-template pTemplate="footer">
      <p-button icon="pi pi-check" (click)="rejectApplication()" label="Decline" styleClass="p-button-text"></p-button>
    </ng-template>
  </p-dialog>
</p-sidebar>
